import { Col, Row } from "antd";
import { getLocalStorage } from "../../helpers/localstorage";
import { rolesConst, rolesDoesNotHaveAddOrders } from "../../constants/others";
import moment from "moment";

const DisplayOrder = (props) => {
    const { order } = props
    const user = getLocalStorage("auth")?.user
    return (
        <>
            <Row gutter={[1, 8]}>
                <Col xs={24} md={12} lg={8}>
                    <strong>Nom:</strong>
                    <div>{order.name}</div>
                </Col>
                <Col xs={24} md={12} lg={8}>
                    <strong>Prefix:</strong>
                    <div>{order.prefix}</div>
                </Col>
                <Col xs={24} md={12} lg={8}>
                    <strong>Téléphone:</strong>
                    <div>{order.phone}</div>
                </Col>
                <Col xs={24} md={12} lg={8}>
                    <strong>Prix:</strong>
                    <div>{order.price}</div>
                </Col>
                {/* <Col xs={24} md={12} lg={8}>
                    <strong>Unité:</strong>
                    <div>{order.orderedProduct.unit}</div>
                </Col> */}
                <Col xs={24} md={12} lg={8}>
                    <strong>Produit:</strong>
                    <div>{order.productName}</div>
                </Col>
                {order.orderedProduct?.some(op => op.selectedOptions?.length > 0) && (
                    <Col xs={24}>
                        <strong>Tailles / Couleurs:</strong>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 4, marginTop: 4 }}>
                            {order.orderedProduct.map((op, opi) =>
                                op.selectedOptions?.map((opt, i) => (
                                    <div key={`${opi}-${i}`} style={{ display: 'flex', gap: 12, fontSize: 13 }}>
                                        <span><strong>#{i + 1}</strong></span>
                                        {opt.size && <span>Taille: <strong>{opt.size}</strong></span>}
                                        {opt.color && <span>Couleur: <strong>{opt.color}</strong></span>}
                                    </div>
                                ))
                            )}
                        </div>
                    </Col>
                )}
                <Col xs={24} md={12} lg={8}>
                    <strong>Ville:</strong>
                    <div>{order.cityName}</div>
                </Col>
                <Col xs={24} md={12} lg={8}>
                    <strong>Date de comande:</strong>
                    <div>{moment(order.orderDate).format('YYYY-MM-DD')}</div>
                </Col>
                <Col xs={24} md={12} lg={8}>
                    <strong>Date de saisi:</strong>
                    <div>{moment(order.createdAt).format('YYYY-MM-DD HH:mm')}</div>
                </Col>
                <Col xs={24} md={12} lg={8}>
                    <strong>Confirmation statut:</strong>
                    <div>{order.confimationStatus}</div>
                </Col>
                <Col xs={24} md={12} lg={8}>
                    <strong>Livraison statut:</strong>
                    <div>{order.deliveryStatus}</div>
                </Col>
                <Col xs={24} md={12} lg={8}>
                    <strong>Societe de livraison:</strong>
                    <div>{order.deliveryCompany.name}</div>
                </Col>
                {order.deliveryCompanyKey && <Col xs={24} md={12} lg={8}>
                    <strong>compte de livraison:</strong>
                    <div>{order.deliveryCompanyKey.name}</div>
                </Col>}
                {user.role.toLocaleLowerCase() !== rolesConst.Deliveryman.toLocaleLowerCase() && order.deliveryMan && <>
                    <Col xs={24} md={12} lg={8}>
                        <strong>Nom Livreur:</strong>
                        <div>{order.deliveryMan.name}</div>
                    </Col>
                    <Col xs={24} md={12} lg={8}>
                        <strong>Contact Livreur:</strong>
                        <div>{order.deliveryMan.phone}</div>
                    </Col>
                </>}
                {rolesDoesNotHaveAddOrders.includes(user.role.toLocaleLowerCase()) && order.deliveryMan && <>
                    <Col xs={24} md={12} lg={8}>
                        <strong>Nom Confiramation:</strong>
                        <div>{order.user.name}</div>
                    </Col>
                    <Col xs={24} md={12} lg={8}>
                        <strong>Contact Confiramation:</strong>
                        <div>{order.user.phone}</div>
                    </Col>
                </>}
                <Col span={24}>
                    <strong>Adresse:</strong>
                    <p>{order.address}</p>
                </Col>
                {order.note?.length > 0 && <Col span={24}>
                    <hr />
                    <Col span={24}><h3>Notes</h3></Col>
                    <Row>
                        <Col span={6}>
                            <strong>Utilisateur</strong>
                        </Col>
                        <Col span={6}>
                            <strong>Role</strong>
                        </Col>
                        <Col span={6}>
                            <strong>Note</strong>
                        </Col>
                        <Col span={6}>
                            <strong>Date</strong>
                        </Col>
                    </Row>
                    <Row>
                        {order.note.map((el) => (
                            <>
                                <Col span={6}>
                                    <span>{el.user.name}</span>
                                </Col>
                                <Col span={6}>
                                    <span>{el.user.role}</span>
                                </Col>
                                <Col span={6}>
                                    <span>{el.content}</span>
                                </Col>
                                <Col span={6}>
                                    <span>{moment(el.createdAt).format('YYYY-MM-DD HH:mm:ss')}</span>
                                </Col>
                            </>
                        ))}
                    </Row>
                </Col>}
            </Row>
        </>
    );
}

export default DisplayOrder;